// Menu Configurations

export const CfgMnu = {
	user: {
		title		: "User Menu",
		bg_color	: "transparent",
		std_color	: "#AAA",
		hot_color	: "#369",
		locs: [
			{path:"/"		,ico:"home"		,title:"Home"		,tooltip:"What I Ate! App Home"},
			{path:"/search"	,ico:"mag"		,title:"Search"		,tooltip:"Search Articles"},
			{path:"/arts"	,ico:"list"		,title:"Articles"	,tooltip:"View Articles List"},
			{path:"/upload"	,ico:"upload"	,title:"Upload"		,tooltip:"Upload Your Story"},
			{path:"/about"	,ico:"info"		,title:"About"		,tooltip:"About What I Ate!"},
			{path:"/contact",ico:"message"	,title:"Contact"	,tooltip:"Contact Us"},
			{path:"/tos"	,ico:"ribbon"	,title:"TOS"		,tooltip:"Terms of Service"},
		],
	},
	admin: {
		title		: "Admin Menu",
		bg_color	: "#EEF9EE",
		std_color	: "#AAA",
		hot_color	: "#090",
		locs: [
			{path:"/adm/info"	,ico:"info"		,title:"Info"		,tooltip:"App Info"	},
			{path:"/adm/settings",ico:"gear"	,title:"Settings"	,tooltip:"Settings"	},
		],
	},
	links: {
		title		: "Site Links",
		bg_color	: "#FFF",
		std_color	: "#AAA",
		hot_color	: "#F60",
		locs: [
			{path:"/arts"		,ico:""	,title:"Articles"	,tooltip:"View Article List"},
			{path:"/advertise"	,ico:""	,title:"Advertise"	,tooltip:"Advertise"},
			{path:"/404"		,ico:""	,title:"404"		,tooltip:"Missing Article"},
			{path:"/xxx"		,ico:""	,title:"Bad Link"	,tooltip:"Missing Article"},
			{path:"/missing"	,ico:""	,title:"Bad Link"	,tooltip:"Missing Article"},
			{path:"/some/place"	,ico:""	,title:"Bad Link"	,tooltip:"Terms of Service"},
		],
	},
	bldUni: {
		title		: "Builder: Universal",
		bg_color	: "#FCF3F3",
		std_color	: "#AAA",
		hot_color	: "#F60",
		locs: [
			{path:"/bld/startup"	,ico:""	,title:"Startup"	,tooltip:"Startup Builder"},
			{path:"/bld/ico"		,ico:""	,title:"Icons"		,tooltip:"Icon Builder"},
			{path:"/bld/menu"		,ico:""	,title:"Menus"		,tooltip:"Menu Builder"},
			{path:"/bld/pager"		,ico:""	,title:"Pager"		,tooltip:"Pager Builder"},
			{path:"/bld/popwin"		,ico:""	,title:"PopWin"		,tooltip:"Pop Window Builder"},
			{path:"/bld/form"		,ico:""	,title:"PopForm"	,tooltip:"Pop Form Builder"},
			{path:"/bld/state"		,ico:""	,title:"State"		,tooltip:"State/Store Builder"},
			{path:"/bld/comm"		,ico:""	,title:"Comm"		,tooltip:"Communication Builder"},
			{path:"/bld/dabug"		,ico:""	,title:"DABug"		,tooltip:"DABug Builder"},
			{path:"/bld/mess"		,ico:""	,title:"UniMess"	,tooltip:"Mess Builder"},
		],
	},
	bldApp: {
		title		: "Builder: Application",
		bg_color	: "#FCF3F3",
		std_color	: "#AAA",
		hot_color	: "#F60",
		locs: [
			{path:"/bld/search"			,ico:""	,title:"Search"		,tooltip:"Search"},
			{path:"/bld/uniinput"		,ico:""	,title:"UniInput"	,tooltip:"Uni Input Builder"},
			{path:"/bld/unidate"		,ico:""	,title:"UniDate"	,tooltip:"Uni Date Builder"},
			{path:"/bld/catpick"		,ico:""	,title:"Cats"		,tooltip:"Category Picker"},
			{path:"/bld/catpickbtn"		,ico:""	,title:"Cat Btn"	,tooltip:"Category Picker Button"},
			{path:"/bld/art"			,ico:""	,title:"Article"	,tooltip:"Single Article"},
			{path:"/bld/admedit"		,ico:""	,title:"Adm Edit"	,tooltip:"Admin: Edit Article"},
			{path:"/bld/unipost"		,ico:""	,title:"UniPost"	,tooltip:"UniPost Builder"},
			{path:"/bld/admds"			,ico:""	,title:"DataSource"	,tooltip:"DataSource Builder"},
		],
	},

};
